var ezdia;
(function (ezdia) {
    function paypalIdCheckBoxMarkup(id) {
        return "<div class=\"checkbox\">\n      <label>\n        <input id=" + id + " type=\"checkbox\"> Same as Email.\n      </label>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.compute = {
            paypalIdCheckBoxMarkup: paypalIdCheckBoxMarkup
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
